'use strict';
import * as $j_app$002edata$002eapp$005fdocument$0024package$0024$002dApp$002dDocument$002dVersion$0024 from "./app.data.app_document$package$-App-Document-Version$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_DocumentVersions(v0, others) {
  this.Fu = null;
  this.Bw = null;
  this.Fu = v0;
  this.Bw = others;
}
export { $c_Lapp_data_DocumentVersions as $c_Lapp_data_DocumentVersions };
$p = $c_Lapp_data_DocumentVersions.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_DocumentVersions;
/** @constructor */
function $h_Lapp_data_DocumentVersions() {
}
export { $h_Lapp_data_DocumentVersions as $h_Lapp_data_DocumentVersions };
$h_Lapp_data_DocumentVersions.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_DocumentVersions)) {
    var x = this.Fu;
    var x$2 = x$0.Fu;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().C(this.Bw, x$0.Bw);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "DocumentVersions";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Fu;
  }
  if ((n === 1)) {
    return this.Bw;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "v0";
  }
  if ((n === 1)) {
    return "others";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.btj = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyMapOps(this.Bw).FN.afV();
});
$p.bPd = (function(id) {
  var x = this.btj().a3();
  return ((x === null) ? (id === null) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_equals__O__Z(x, id));
});
$p.bZJ = (function(id) {
  var x = this.Fu;
  if (((x === null) ? (id === null) : x.f(id))) {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_app$002edata$002eapp$005fdocument$0024package$0024$002dApp$002dDocument$002dVersion$0024.$m_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$().a8w);
  } else {
    var this$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyMapOps(this.Bw);
    var m = this$3.FN;
    _return: {
      var it = m.r();
      while (it.l()) {
        var a = it.k();
        var x$1 = a.a3();
        if (((x$1 === null) ? (id === null) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_equals__O__Z(x$1, id))) {
          var this$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(a);
          break _return;
        }
      }
      var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    }
    return (this$5.c() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some((this$5.g().a0() | 0)));
  }
});
$p.bxb = (function() {
  var other$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$().a5V($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_app$002edata$002eapp$005fdocument$0024package$0024$002dApp$002dDocument$002dVersion$0024.$m_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$().a8w, this.Fu));
  var ev$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyVector($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_exts_NonEmptyMapExts$package$NonEmptyMapExts$().bwF(this.Bw)).b0;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$();
  return other$1.nX(ev$3);
});
$p.bZK = (function() {
  var ev$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyVector($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_exts_NonEmptyMapExts$package$NonEmptyMapExts$().bwF(this.Bw)).b0;
  var other$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyVector(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IndexedSeqOps__reverse__O(ev$5))).b0;
  var ev$7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$().a5V($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_app$002edata$002eapp$005fdocument$0024package$0024$002dApp$002dDocument$002dVersion$0024.$m_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$().a8w, this.Fu));
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$();
  return other$2.nX(ev$7);
});
function $isArrayOf_Lapp_data_DocumentVersions(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jp)));
}
export { $isArrayOf_Lapp_data_DocumentVersions as $isArrayOf_Lapp_data_DocumentVersions };
var $d_Lapp_data_DocumentVersions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_DocumentVersions, "app.data.DocumentVersions", ({
  jp: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_DocumentVersions as $d_Lapp_data_DocumentVersions };
//# sourceMappingURL=app.data.-Document-Versions.js.map
